import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { Typography } from "@mui/material";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import * as React from "react";

export const LSResultItemReadingLevelDisplay = ({
  resource,
}: {
  resource: ResourceView | ResourceDWR;
}) => {
  const { locationConfiguration } = useLocationConfiguration();
  const { translate } = useLanguage();

  if (!resource) {
    return null;
  }

  const { lexileEnabled, acceleratedReaderEnabled, displaySettings } =
    locationConfiguration?.pacSettings || {};
  const { displayReadingLevelInSearchResults } = displaySettings || {};
  const { lexileDisplay } = resource?.lexile || {};
  const { bookLevel } = resource?.acceleratedReader || {};

  if (
    !displayReadingLevelInSearchResults ||
    (!lexileEnabled && !acceleratedReaderEnabled) ||
    (!lexileDisplay && !bookLevel)
  ) {
    return null;
  }

  return (
    <Typography component={"h4"} variant={"subtitle2"}>
      {lexileEnabled && lexileDisplay && (
        <>
          {translate("lexileMeasure")}: {lexileDisplay}
        </>
      )}
      {}
      {acceleratedReaderEnabled && bookLevel && (
        <>
          {lexileEnabled && lexileDisplay && <>{", "}</>}
          {translate("atosLevel")}: {bookLevel}
        </>
      )}
    </Typography>
  );
};
